/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import React, { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { IRootState } from "../../config/reducers";
import { LoginForm } from "./LoginForm";
import { getUrlOrganisation } from "../../utils/utils";
import { AuthenticationLayout } from "@src/components/AuthenticationLayout";
import { CPBrandLogo } from "@advapacs/common/src/components/Logo";

export const LoginContainer: FC = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { isAuthenticated } = useSelector(
    (rootState: IRootState) => rootState.loginReducer
  );

  useEffect(() => {
    if (!isAuthenticated) localStorage.removeItem("region");
  }, [isAuthenticated]);

  useEffect(() => {
    if (state) {
      // navigate()
      window.location.href = getUrlOrganisation(state as string);
    }
    return () => {
      if (state) {
        navigate("/");
      }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);
  return (
    <AuthenticationLayout isMultipleBrand={true}>
      <div className="mb-0">
        <div className="logo flex-center">
          <CPBrandLogo
            style={{ left: "50%", transform: "translate(-50%, 0)" }}
            noMargin
            width={220}
            height={70}
          />
        </div>
        <div className="mt-3">
          <LoginForm isSaml={window.location.pathname.includes("/SSO/SAML2")} />
        </div>
      </div>
    </AuthenticationLayout>
  );
};
